import React, { useEffect, useState } from "react";

import { Row, Card } from "react-bootstrap";
import {
  stuacademicyearlist,
  stuclasslist,
  studivisionlist,
  stusubjectlist,
} from "../../../services/master";
import Swal from "sweetalert2";
import { useLocation, useNavigate } from "react-router-dom";
import { academylist, listhomeworkdetail } from "../../../services/admin";
import { classSecitionList } from "../../../services/attendance";
import moment from "moment";
import Select from "react-select";
import { listhomework, teacherfilter } from "../../../services/teacher";
import { studentviewdetail } from "../../../services/student";
import { AgGridReact } from "ag-grid-react";
import { toast } from "react-toastify";

export default function Homeworkdetail() {
  const navigate = useNavigate();
  const [ayear, setAYear] = useState("");
  const [alist, setAList] = useState([]);
  const [sreport, setSReport] = useState("");

  const [stucls, setStuCls] = useState("");
  const [clist, setCList] = useState([]);

  const [stusec, setStuSec] = useState("");
  const [slist, setSList] = useState([]);

  const [subject, setSubject] = useState("");
  const [sublist, setSubList] = useState([]);

  const [adate, setADate] = useState("");
  const [hdate, setHDate] = useState("");

  const [aclist, setACList] = useState([]);
  const [acaid, setAcaID] = useState("");

  const [hwlist, setHWList] = useState([]);
  const [hwpath, setHWPath] = useState("");
  const [allSections, setAllSections] = useState([]);

  const [teaid, setTeaID] = useState("");
  const [tlist, setTList] = useState([]);
  const [fromdate, setFromDate] = useState("");
  const [todate, setToDate] = useState("");
  const [urllink, setUrl] = useState("");
  const location = useLocation();
  useEffect(() => {
    const path = location.pathname.split("/")[2]; // Extracts 'allstudent' or 'leftstudentlist'
    setUrl(path);

    if (localStorage.getItem("ADate") !== '') {
      setADate(moment(localStorage.getItem("ADate")).format("YYYY-MM-DD"));
      setFromDate(moment(localStorage.getItem("ADate")).format("YYYY-MM-DD"));
      setToDate(moment(localStorage.getItem("ADate")).format("YYYY-MM-DD"));
    } else {
      setADate(moment(new Date()).format("YYYY-MM-DD"));
      setFromDate(moment(new Date()).format("YYYY-MM-DD"));
      setToDate(moment(new Date()).format("YYYY-MM-DD"));
    }

    if (localStorage.getItem("Role") !== '4') {
      stuclasslist().then((res) => {
        if (res.status === true) {
          let arr = [];
          if (res.data.length > 0) {
            for (let i = 0; i < res.data.length; i++) {
              arr.push({
                value: res.data[i].id,
                label: res.data[i].class_name,
              });
            }
          }
          setCList(arr);
        }
      });

      studivisionlist().then((res) => {
        if (res.status === true) {
          let arr = [];
          if (res.data.length > 0) {
            for (let i = 0; i < res.data.length; i++) {
              arr.push({
                value: res.data[i].id,
                label: res.data[i].name,
              });
            }
          }
          setSList(arr);
        }
      });

      academylist().then((res) => {
        if (res.status === true) {
          let arr = [];
          if (res.data.details.length > 0) {
            for (let i = 0; i < res.data.details.length; i++) {
              arr.push({
                value: res.data.details[i].id,
                label:
                  res.data.details[i].name + " - " + res.data.details[i].code,
              });
            }
            setACList(arr);
          }
        }
      });
      if (localStorage.getItem("AAcademy") != null) {
        academylist().then((res) => {
          if (res.status === true) {
            let arr = [];
            if (res.data.details.length > 0) {
              for (let i = 0; i < res.data.details.length; i++) {
                if (res.data.details[i].id == localStorage.getItem("AAcademy")) {
                  arr.push({
                    value: res.data.details[i].id,
                    label:
                      res.data.details[i].name + " - " + res.data.details[i].code,
                  });
                }
                if (arr.length > 0) {
                  setAcaID(arr[0]);
                  listyear(arr[0]);
                  setAYear(localStorage.getItem("AYear"));
                  loadAllSections(arr[0]);
                }
              }

            }
          }
        });
      } else {
        listyear("");
      }

      if (localStorage.getItem("ADate") !== '') {
        listall("", "", "", "", "", moment(localStorage.getItem("ADate")).format("YYYY-MM-DD"), moment(localStorage.getItem("ADate")).format("YYYY-MM-DD"));
      } else {
        listall("", "", "", "", "", moment(new Date()).format("YYYY-MM-DD"), moment(new Date()).format("YYYY-MM-DD"));
      }
      loadAllSections(localStorage.getItem("academy") || 0);
    } else if (localStorage.getItem("Role") === '4') {

     
      studentviewdetail(localStorage.getItem("UID")).then((response) => {
        if (response.status === true && response.data.details !== null) {
          academylist().then((res) => {
            if (res.status === true) {
              let arr = [];
              if (res.data.details.length > 0) {
                for (let i = 0; i < res.data.details.length; i++) {
                  if (res.data.details[i].id === response.data.details.academy_id) {
                    arr.push({
                      value: res.data.details[i].id,
                      label:
                        res.data.details[i].name + " - " + res.data.details[i].code,
                    });
                  }
                }
                setAcaID(arr[0]);
              }
            }
          });
          if (localStorage.getItem("ADate") !== '') {

            listall(response.data.details.academy_id, response.data.details.academicyear, response.data.details.class_id, response.data.details.section_id, "",  moment(localStorage.getItem("ADate")).format("YYYY-MM-DD"), moment(localStorage.getItem("ADate")).format("YYYY-MM-DD"));
          } else {
            listall(response.data.details.academy_id, response.data.details.academicyear, response.data.details.class_id, response.data.details.section_id, "", moment(new Date()).format("YYYY-MM-DD"), moment(new Date()).format("YYYY-MM-DD"));
          }
        }
      })
    }


   

  }, [location.pathname]);

  function listall(aca, ayr, acls, asec, sub, hte, dte) {
    setHWList([]);
    setAYear(ayr);
    setStuCls(acls);
    setStuSec(asec);
    setSubject(sub);
    setHDate(hte);
    setADate(dte);
    const temp = new FormData();
    if (localStorage.getItem("Role") === "1" && aca !== "") {
      temp.append("academy", aca.value);
    }
    temp.append("academic_year", ayr);
    temp.append("class_id", acls);
    temp.append("section", asec);
    temp.append("subject", sub);
    temp.append("due_date", dte);
    temp.append("from_date", hte);

    listhomework(temp).then((res) => {
      if (res.status === true) {
        // setHWList(res.data.details);
        setHWPath(res.data.path);
        if (res.data.details.length > 0) {
          const hdata = res.data.details.map(item => {
            return {
              ...item,
              due_date: moment(item.due_date).format("DD-MM-YYYY"),
            }
          })
          setHWList(hdata);
        }
      }
    });
  }

  function deletehw(e) {
    e.preventDefault();
    Swal.fire({
      title: "Are you sure want to delete?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    });
  }

  function handleAcademy(e) {
    setFilterProduct([]);
    if (e !== null) {
      setAcaID(e);
      listall(e, ayear, stucls, stusec, subject, hdate, adate);
      listyear(e);
      loadAllSections(e);
    } else {
      setAcaID("");
      listall("", ayear, stucls, stusec, subject, hdate, adate);
      listyear("");
      setAllSections([]);
    }
  }

  function listyear(aid) {
    setAList([]);
    setAYear("");
    const temp = new FormData();
    if (localStorage.getItem("Role") === "1" && aid !== "") {
      temp.append("academy_id", aid.value);
    }
    stuacademicyearlist(temp).then((res) => {
      if (res.status === true) {
        let arr = [];
        if (res.data.length > 0) {
          for (let i = 0; i < res.data.length; i++) {
            arr.push({
              value: res.data[i].id,
              label: res.data[i].aca_year,
            });
          }
        }
        setAList(arr);
      }
    });

     stusubjectlist(temp).then((res) => {
      if (res.status === true) {
        setSubList(res.data);
      }
    });


    if (urllink === "homeworkreport") {
      const temp1 = new FormData();
      if (localStorage.getItem("Role") === "1" && aid !== "") {
        temp1.append("academy", aid.value);
      }
      teacherfilter(temp1).then((res) => {
        if (res.status === true) {
          let arr = [];
          if (res.data.details.length > 0) {
            for (let i = 0; i < res.data.details.length; i++) {
              arr.push({
                value: res.data.details[i].teacher_id,
                label: res.data.details[i].username + " - " + res.data.details[i].teacher_name,
              });
            }
            setTList(arr);
          }
        }
      })
    }
  }

  function loadAllSections(aca) {
    const acaId = aca !== "" && aca ? aca.value || aca : (localStorage.getItem("academy") || 0);
    classSecitionList(acaId).then((res) => {
      if (res && res.status === true) {
        setAllSections(res.data);
      }
    });
  }

  function errorphoto(ev) {
    ev.target.src = require("../../../assets/images/user.png");
    ev.target.onerror = null;
  }

  function errorhome(ev) {
    ev.target.src = require("../../../assets/images/photo.png");
    ev.target.onerror = null;
  }

  const [loading, setLoading] = useState(false);

  function handleTeacher(e) {
    if (e !== null) {
      setTeaID(e);
      listrep(acaid, ayear, stucls, stusec, e, fromdate, todate);
    } else {
      setTeaID("");
      listrep(acaid, ayear, stucls, stusec, "", fromdate, todate);
    }
  }

  function listrep(aca, ayr, cls, sec, tid, fdate, tdate) {
    setAYear(ayr);
    setStuCls(cls);
    setStuSec(sec);
    setFromDate(fdate);
    setToDate(tdate);
    setFilterProduct([]);

    const temp = new FormData();
    if (localStorage.getItem("Role") === "1" && aca !== "") {
      temp.append("academy_id", aca.value);
    } else {
      temp.append("academy_id", localStorage.getItem("academy"));
    }
    temp.append("academic_year", ayr);
    temp.append("class_id", cls);
    temp.append("section_id", sec);
    temp.append("from_date", fdate);
    temp.append("to_date", tdate);

    if (tid !== "") {
      temp.append("teacher_id", tid.value);
    }
    listhomeworkdetail(temp).then((res) => {
      if (res.status === true) {
        const mappedData = res.data.details.map(item => {

          return {
            ...item,
            due_date: moment(item.due_date).format("DD-MM-YYYY"),
          };
        });
        setFilterProduct(mappedData);
      }
    });
  }

  const columnADefs = [
    {
      headerName: "Action",
      field: "id",
      width: 130,
      sortable: true,
      resizable: true,
      filter: false,
      floatingFilter: false,
      cellStyle: { textAlign: "left" },
      cellRenderer: (params) => (
        <div className="text-center">
          <a
            className="btn-sm btn-secondary me-2"
            onClick={() =>
              navigate(`/homework/viewhomework/` + params.value)
            }
          >
            <i className="fa fa-eye"></i>
          </a>
          <a
            className="btn-sm btn-success me-2"
            onClick={() =>
              navigate(`/homework/homeworkdetail/` + params.value)
            }
          >
            <i className="fa fa-edit"></i>
          </a>
          <a
            title="Delete"
            onClick={() => {
              deletehw(params.value);
            }}
            className="btn-sm btn-danger"
          >
            <i className="fa fa-trash"></i>
          </a>
        </div>
      )
    },
    {
      headerName: "Photo",
      field: "teacher_photo",
      width: 100,
      sortable: true,
      resizable: true,
      filter: false,
      floatingFilter: false,
      cellStyle: { textAlign: "left" },
      cellRenderer: function (params) {
        if (params.teacher_photo !== null) {
          return (
            <div className="text-center">
              <img width={"50px"} height={"50px"}
                src={
                  hwpath +
                  params.academy_code +
                  "/teacher/" +
                  params.teacher_photo
                }
                alt="Teacher"
                onError={errorphoto}
              />
            </div>
          )
        } else {
          return (
            <div className="text-center">
              <img
                src={require("../../../assets/images/teacher.jpg")}
                alt="Teacher"
              />
            </div>
          )
        }

      }
    },
    {
      headerName: "Teacher Name",
      field: "teacher_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    // {
    //   headerName: "Username",
    //   field: "username",
    //   sortable: true,
    //   resizable: true,
    //   filter: true,
    //   floatingFilter: true,
    //   cellStyle: { textAlign: "left" },
    // },
    {
      headerName: "Subject",
      field: "subject_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Description",
      field: "description",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Class",
      field: "class_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },

    {
      headerName: "Section",
      field: "section_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Due Date",
      field: "due_date",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
  ];

  const [filterProduct, setFilterProduct] = useState([]);
  const columnDefs = [
    {
      headerName: "Action",
      field: "id",
      width: 100,
      sortable: true,
      resizable: true,
      filter: false,
      floatingFilter: false,
      cellStyle: { textAlign: "left" },
      cellRenderer: (params) => (
        <div className="text-center">
          <a
            className="btn-sm btn-secondary me-2"
            onClick={() =>
              navigate(`/homework/viewhomework/` + params.value)
            }
          >
            <i className="fa fa-eye"></i>
          </a>
        </div>
      )
    },
    {
      headerName: "Teacher Name",
      field: "teacher_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Username",
      field: "username",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Subject",
      field: "subject_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Description",
      field: "description",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Class",
      field: "class_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },

    {
      headerName: "Section",
      field: "section_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Due Date",
      field: "due_date",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
  ];

  function submitrep(e) {
    e.preventDefault();
    let valid = "";
    if (localStorage.getItem("Role") === "1") {
      if (acaid === "") {
        valid = "Please Select Academy";
        toast.error(valid);
        return
      }
    }
    let stu = teaid ? teaid.value : ''

    let aca = ''
    if (localStorage.getItem("Role") === "1" && acaid !== "") {
      aca = acaid.value
    } else if (localStorage.getItem("Role") !== "1") {
      aca = localStorage.getItem("academy")
    }
    const reportUrl = localStorage.getItem("reportUrl");
    window.open(reportUrl + 'report/homeworkexcel?academy_id=' + aca + '&from_date=' + fromdate + '&to_date=' + todate + '&teacher_id=' + stu + '&class_id=' + stucls + '&section_id=' + stusec + '&academic_year=' + ayear, "_blank");

  }

  return (
    <div>
      <div className="page-header">
        <h2 className="main-content-title tx-24 mg-b-5">{urllink === "homeworkreport" ? "HomeWork Report" : "All HomeWork"}</h2>
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a>{urllink === "homeworkreport" ? "Report" : "HomeWork"}</a>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            {urllink === "homeworkreport" ? "HomeWork Report" : "All HomeWork"}
          </li>
        </ol>
      </div>
      {loading && (
        <div className="loader-wrapper">
          <div className="loader"></div>
          <h3>Loading...Please do not go back or close the window.</h3>
        </div>
      )}
      {!loading && (
        <>
          <Card className="custom-card">
            <Card.Body>
              <div className="row">
                {localStorage.getItem("Role") === "1" && (
                  <div className="col-xl-4 col-sm-6">
                    <div className="mb-3">
                      <label className="form-label">
                        Select Academy <span className="text-danger"> *</span>
                      </label>
                      <Select
                        className="default-select"
                        placeholder="Select Academy"
                        value={acaid}
                        options={aclist}
                        onChange={handleAcademy}
                        isSearchable={true}
                        isClearable
                        hidden
                      />
                    </div>
                  </div>
                )}
                {urllink === "homeworkreport" && (
                  <>
                    <div className="col-xl-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label">Type</label>
                        <select
                          className="default-select form-control wide"
                          value={sreport}
                          onChange={(e) => {
                            setTeaID("");
                            setStuCls("");
                            setStuSec("");
                            setFilterProduct([]);
                            setSReport(e.target.value);
                            listrep(
                              acaid,
                              ayear,
                              stucls,
                              stusec,
                              teaid,
                              fromdate,
                              todate
                            )
                          }}
                        >
                          <option value="" disabled>
                            {" "}
                            Select Type
                          </option>
                          <option value='Student'>
                            Studentwise Report
                          </option>
                          <option value='Teacher'>
                            Teacherwise Report
                          </option>
                        </select>
                      </div>
                    </div>
                    <div className="col-xl-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label">Academic Year</label>
                        <select
                          className="default-select form-control wide"
                          value={ayear}
                          onChange={(e) =>
                            listrep(
                              acaid,
                              e.target.value,
                              stucls,
                              stusec,
                              teaid,
                              fromdate,
                              todate
                            )
                          }
                        >
                          <option value="" disabled>
                            Select Academic Year
                          </option>
                          {alist.map((item, i) => (
                            <option value={item.value} key={i}>
                              {item.label}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    {sreport === "Student" && (
                      <>
                        <div className="col-xl-3 col-sm-6">
                          <div className="mb-3">
                            <label className="form-label">Class</label>
                            <select
                              className="default-select form-control wide"
                              value={stucls}
                              onChange={(e) =>
                                listrep(
                                  acaid,
                                  ayear,
                                  e.target.value,
                                  stusec,
                                  teaid,
                                  fromdate,
                                  todate
                                )
                              }
                            >
                              <option value="" disabled>
                                Select Class
                              </option>
                              {clist.map((item, i) => (
                                <option value={item.value} key={i}>
                                  {item.label}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                        <div className="col-xl-3 col-sm-6">
                          <div className="mb-3">
                            <label className="form-label">Section</label>
                            <select
                              className="default-select form-control wide"
                              value={stusec}
                              onChange={(e) =>
                                listrep(
                                  acaid,
                                  ayear,
                                  stucls,
                                  e.target.value,
                                  teaid,
                                  fromdate,
                                  todate
                                )
                              }
                            >
                              <option value="" disabled>
                                Select Section
                              </option>
                              {slist.map((item, i) => (
                                <option value={item.value} key={i}>
                                  {item.label}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                        <div className="col-xl-2 col-sm-6">
                          <label className="form-label">From Due Date</label>
                          <input
                            type="date"
                            className="form-control"
                            value={fromdate}
                            onChange={(e) => listrep(acaid, ayear, stucls, stusec, teaid, e.target.value, todate)}
                          />
                        </div>
                        <div className="col-xl-2 col-sm-6">
                          <label className="form-label">To Due Date</label>
                          <input
                            type="date"
                            className="form-control"
                            value={todate}
                            onChange={(e) => listrep(acaid, ayear, stucls, stusec, teaid, fromdate, e.target.value)}
                          />
                        </div>
                        <div className="col-xl-2 col-sm-6">
                          <div className="res-right mt-5">
                            <button className="btn btn-success me-2" onClick={submitrep}>
                              Excel Download
                            </button>

                          </div>
                        </div>
                      </>
                    )}
                    {sreport === "Teacher" && (
                      <>
                        <div className="col-xl-3 col-sm-6">
                          <div className="mb-3">
                            <label className="form-label">Teacher</label>
                            <Select
                              className="default-select"
                              placeholder="Select Teacher"
                              value={teaid}
                              options={tlist}
                              onChange={handleTeacher}
                              isSearchable={true}
                              isClearable
                              hidden
                            />
                          </div>
                        </div>
                        <div className="col-xl-3 col-sm-6">
                          <label className="form-label">From Due Date</label>
                          <input
                            type="date"
                            className="form-control"
                            value={fromdate}
                            onChange={(e) => listrep(acaid, ayear, stucls, stusec, teaid, e.target.value, todate)}
                          />
                        </div>
                        <div className="col-xl-3 col-sm-6">
                          <label className="form-label">To Due Date</label>
                          <input
                            type="date"
                            className="form-control"
                            value={todate}
                            onChange={(e) => listrep(acaid, ayear, stucls, stusec, teaid, fromdate, e.target.value)}
                          />
                        </div>
                        <div className="col-xl-3 col-sm-6">
                          <div className="res-right mt-5">
                            <button className="btn btn-success me-2" onClick={submitrep}>
                              Excel Download
                            </button>

                          </div>
                        </div>
                      </>
                    )}

                  </>
                )}

                {localStorage.getItem("Role") !== "4" && urllink !== "homeworkreport" && (
                  <>
                    <div className="col-xl-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label">Academic Year</label>
                        <select
                          className="default-select form-control wide"
                          value={ayear}
                          onChange={(e) =>
                            listall(
                              acaid,
                              e.target.value,
                              stucls,
                              stusec,
                              subject,
                              hdate,
                              adate
                            )
                          }
                        >
                          <option value="" disabled>
                            Select Academic Year
                          </option>
                          {alist.map((item, i) => (
                            <option value={item.value} key={i}>
                              {item.label}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-xl-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label">Class</label>
                        <select
                          className="default-select form-control wide"
                          value={stucls}
                          onChange={(e) =>
                            listall(
                              acaid,
                              ayear,
                              e.target.value,
                              stusec,
                              subject,
                              hdate,
                              adate
                            )
                          }
                        >
                          <option value="" disabled>
                            Select Class
                          </option>
                          {clist.map((item, i) => (
                            <option value={item.value} key={i}>
                              {item.label}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-xl-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label">Section</label>
                        <select
                          className="default-select form-control wide"
                          value={stusec}
                          onChange={(e) =>
                            listall(
                              acaid,
                              ayear,
                              stucls,
                              e.target.value,
                              subject,
                              hdate,
                              adate
                            )
                          }
                        >
                          <option value="" disabled>
                            Select Section
                          </option>
                          {slist.map((item, i) => (
                            <option value={item.value} key={i}>
                              {item.label}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </>
                )}



                {urllink !== "homeworkreport" && (
                  <>
                    <div className="col-xl-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label">Subject</label>
                        <select
                          className="default-select form-control wide"
                          value={subject}
                          onChange={(e) =>
                            listall(
                              acaid,
                              ayear,
                              stucls,
                              stusec,
                              e.target.value,
                              hdate,
                              adate
                            )
                          }
                        >
                          <option value="" disabled>
                            {" "}
                            Select Subject
                          </option>
                          {sublist.map((item, i) => (
                            <option value={item.id} key={i}>
                              {item.subject_name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-xl-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label">From Due Date</label>
                        <input
                          type="date"
                          className="form-control"
                          value={hdate}
                          onChange={(e) =>
                            listall(
                              acaid,
                              ayear,
                              stucls,
                              stusec,
                              subject,
                              e.target.value,
                              adate
                            )
                          }
                        />
                      </div>
                    </div> 
                    <div className="col-xl-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label">To Due Date</label>
                        <input
                          type="date"
                          className="form-control"
                          value={adate}
                          min={hdate}
                          onChange={(e) =>
                            listall(
                              acaid,
                              ayear,
                              stucls,
                              stusec,
                              subject,
                              hdate,
                              e.target.value
                            )
                          }
                        />
                      </div>
                    </div> 
                    {/* <div className="col-xl-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label">Due Date</label>
                        <input
                          type="date"
                          className="form-control"
                          value={adate}
                          onChange={(e) =>
                            listall(
                              acaid,
                              ayear,
                              stucls,
                              stusec,
                              subject,
                              hdate,
                              e.target.value
                            )
                          }
                        />
                      </div>
                    </div> */}
                  </>

                )}

              </div>
              {urllink === "homeworkreport" && (
                <div className="row">
                  <div className="ag-theme-alpine ag-style mt-2">
                    <AgGridReact
                      columnDefs={columnDefs}
                      rowData={filterProduct}
                      pagination="true"
                      paginationPageSize="10"
                      sortingOrder={["asc", "desc"]}
                      suppressDragLeaveHidesColumns={true}
                    />
                  </div>
                </div>
              )}
            </Card.Body>
          </Card>

          {urllink !== "homeworkreport" && localStorage.getItem("Role") !== "4" && allSections.length > 0 && (() => {
            const markedSet = new Set(hwlist.map(item => item.class_name + "||" + item.section_name));
            return (
              <div className="card custom-card mt-3 mb-3">
                <div className="card-header d-flex justify-content-between align-items-center">
                  <h5 className="mb-0 text-white">Homework Status</h5>
                  <div className="d-flex gap-3">
                    <span className="text-white me-3"><span style={{ display: "inline-block", width: 12, height: 12, borderRadius: "50%", backgroundColor: "#28a745", marginRight: 4 }}></span>Allocated</span>
                    <span className="text-white"><span style={{ display: "inline-block", width: 12, height: 12, borderRadius: "50%", backgroundColor: "#dc3545", marginRight: 4 }}></span>Not Allocated</span>
                  </div>
                </div>
                <div className="card-body">
                  <div className="row">
                    {allSections.map((sec, i) => {
                      const hasHW = markedSet.has(sec.class_name + "||" + sec.section_name);
                      return (
                        <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 mb-2" key={i}>
                          <div className="text-center py-2 px-1 rounded" style={{
                            backgroundColor: hasHW ? "#d4edda" : "#f8d7da",
                            border: `1px solid ${hasHW ? "#28a745" : "#dc3545"}`,
                          }}>
                            <span className="fw-bold tx-13" style={{ color: hasHW ? "#155724" : "#721c24" }}>
                              {sec.class_name} - {sec.section_name}
                            </span>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            );
          })()}

          <Row className=" row-sm">
            {localStorage.getItem("Role") <= 2 &&
              <div className="ag-theme-alpine ag-style">
                <AgGridReact
                  columnDefs={columnADefs}
                  rowData={hwlist}
                  pagination="true"
                  paginationPageSize="10"
                  sortingOrder={["asc", "desc"]}
                  suppressDragLeaveHidesColumns={true}
                />
              </div>
            }
            {localStorage.getItem("Role") > 2 &&
              <div className="col-12">
                {hwlist.length === 0 && (
                  <div className="text-center">
                    <h6 className="text-danger">No HomeWork Found</h6>
                  </div>
                )}
                {hwlist.map((item, i) => (
                  <Card className=" mg-b-20 border" key={i}>
                    <div className="p-4 card-headerr">
                      <div className="media">
                        <div className="media-user me-2">
                          <div className="main-img-user avatar-md">
                            {item.teacher_photo !== null && (
                              <img
                                src={
                                  hwpath +
                                  item.academy_code +
                                  "/teacher/" +
                                  item.teacher_photo
                                }
                                alt="Teacher"
                                onError={errorphoto}
                              />
                            )}
                            {item.teacher_photo === null && (
                              <img
                                src={require("../../../assets/images/teacher.jpg")}
                                alt="Teacher"
                              />
                            )}
                          </div>
                        </div>
                        <div className="media-body">
                          <h6 className="mb-0 mg-t-2 ms-2">
                            {item.teacher_name}
                            <span className="text-muted ms-2">
                              {moment(item.created_at).format("MMM DD YYYY")}
                            </span>
                          </h6>
                          <span className="text-primary ms-2">
                            {item.subject_name}
                          </span>
                          <b className="text-danger ms-5">
                            Due Date:{item.due_date}
                          </b>
                        </div>
                        {localStorage.getItem("Role") !== "4" &&
                          <div className="text-right">
                            <a
                              className="btn btn-sm btn-success me-2"
                              onClick={() =>
                                navigate(`/homework/homeworkdetail/` + item.id)
                              }
                            >
                              <i className="fa fa-edit"></i> Edit
                            </a>
                            <a
                              className="btn btn-sm btn-danger me-2"
                              onClick={() => {
                                deletehw(item.id);
                              }}
                            >
                              <i className="fa fa-trash"></i> Delete
                            </a>
                          </div>
                        }

                      </div>
                    </div>
                    <Card.Body>
                      <p className="mg-t-0">{item.description}</p>
                      <Row className=" row-sm">
                        <div className="col">
                          {item &&
                            item.work_file &&
                            (item.work_file.split(".").pop() === "pdf" ? (
                              <a
                                href={
                                  hwpath +
                                  item.academy_code +
                                  "/homework/" +
                                  item.work_file
                                }
                                target="_blank"
                              >
                                <img
                                  src={require("../../../assets/images/pdf.png")}
                                  alt="PDF File"
                                  width={"100px"}
                                  height={"100px"}
                                />
                              </a>
                            ) : (
                              <a
                                href={
                                  hwpath +
                                  item.academy_code +
                                  "/homework/" +
                                  item.work_file
                                }
                                target="_blank"
                              >
                                <img
                                  src={hwpath +
                                    item.academy_code +
                                    "/homework/" +
                                    item.work_file}
                                  alt="Other File"
                                  width={"100px"}
                                  height={"100px"}
                                  onerror={(ev) => errorhome(ev)}
                                />
                              </a>
                            ))}
                        </div>
                      </Row>
                    </Card.Body>
                  </Card>
                ))}
              </div>

            }

          </Row>
        </>
      )}
    </div>
  );
}
